/**
=========================================================

* Tazi Rides Ltd has developed this dashboard based on a further configured version of the original template.
* Website: https://www.tazirides.co.uk
* All rights reserved.

=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

* This template has been built upon, with additional code and configuration by Tazi Rides Ltd.
*/

import { ReactNode } from 'react'

// @mui material components
import Card from '@mui/material/Card'
import Icon from '@mui/material/Icon'

// Material Dashboard 2 PRO React TS components
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'

export interface ComplexStatisticsCardData {
	title: string
	value: number
}
// Declaring props types for CompleStatisticsCard
interface Props {
	color?: 'primary' | 'secondary' | 'info' | 'success' | 'warning' | 'error' | 'light' | 'dark'
	title: string
	count: string | number
	icon: ReactNode
	height?: string
	data?: ComplexStatisticsCardData[]
	[key: string]: any
}

function ComplexStatisticsCard({
	color,
	title,
	count,
	icon,
	height,
	data = [],
}: Props): JSX.Element {
	return (
		<Card>
			<MDBox display="flex" justifyContent="space-between" pt={1} px={2} height={height}>
				<MDBox
					variant="gradient"
					bgColor={color}
					color={color === 'light' ? 'dark' : 'white'}
					coloredShadow={color}
					borderRadius="xl"
					display="flex"
					justifyContent="center"
					alignItems="center"
					width="4rem"
					height="4rem"
					mt={-3}
				>
					<Icon fontSize="medium" color="inherit">
						{icon}
					</Icon>
				</MDBox>
				<MDBox textAlign="right" lineHeight={1.25}>
					<MDTypography variant="h6" fontWeight="light" color="text">
						{title}
					</MDTypography>
					<MDTypography variant="h2">{count}</MDTypography>
				</MDBox>
			</MDBox>
			<MDBox display="flex" justifyContent="space-between" alignItems="center" px={2} py={1}>
				{data.map((item, index) => {
					return (
						<MDBox
							pb={2}
							px={2}
							display={'flex'}
							alignItems={'center'}
							flexDirection={'column'}
							key={index}
						>
							<MDTypography
								component="p"
								variant="body2"
								color="text"
								display="flex"
								alignItems="center"
							>
								{item.title}
							</MDTypography>
							<MDTypography
								component="p"
								variant="body2"
								color="text"
								display="flex"
								alignItems="center"
							>
								{item.value}
							</MDTypography>
						</MDBox>
					)
				})}
			</MDBox>
		</Card>
	)
}

// Declaring defualt props for ComplexStatisticsCard
ComplexStatisticsCard.defaultProps = {
	color: 'info',
	percentage: {
		color: 'success',
		text: '',
		label: '',
	},
}

export default ComplexStatisticsCard
